<template>
  <BaseCard v-test="'register-order-service-package'">
    <Flex
      direction="column"
      :gap="0.5"
    >
      <Flex
        justify="between"
        align="center"
      >
        <Flex
          align="center"
          :gap="0.5"
        >
          <BaseLabel color="primary">
            {{ filters.capitalize($t('global.items.package', 1)) }}
          </BaseLabel>
          <BaseText
            bold
            v-test="'register-order-service-package-name'"
          >
            {{ servicePackage.name }}
          </BaseText>
        </Flex>
        <BaseMore
          :options="['duplicate', 'delete']"
          inline
          size="s"
          @select="onSelectAction"
          v-test="'register-order-service-package-options'"
        />
      </Flex>
      <OrderItem
        v-for="index in indexes"
        :key="order.items[index]._uid"
        :item="order.items[index]"
        :index="index"
        inPackage
      />
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import Flex from '@/components/layout/Flex.vue';
import filters from '@/filters';
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import type { ServicePackage } from '@/types';
import OrderItem from './OrderItem.vue';

const props = defineProps<{
  servicePackage: ServicePackage;
  indexes: number[];
}>();

const { order, duplicateServicePackage, removeServicePackage } =
  useRegisterOrderStore();

const onSelectAction = (action: string) => {
  const uids = props.indexes.map((index) => order.items[index]._uid);

  switch (action) {
    case 'duplicate':
      duplicateServicePackage(uids);
      break;
    case 'delete':
      removeServicePackage(uids);
      break;
  }
};
</script>
